import { ReactNode } from "react"
import "./../../style/scroll.css"
import { Authorized } from "../authentication/Authorized"
import { TPermission } from "../../auth/permissions"

export type ColumnType = {
    label: string
    responsive?: string
    classProps?: string
    textDirection?: string
    width?: string
    permissions?: TPermission[]
}

type BaseTableType = {
    columns: ColumnType[]
    tbody: ReactNode
}

export default function BaseTable(props: BaseTableType) {
    return (
        <div className="w-full hide-horizontal-scrollbar">
            <table className="table table-md table-pin-rows bg-white shadow-lg">
                <thead>
                    <tr className=" h-12 bg-gray-100 border-none text-sm ">
                        {props.columns.map((item) => (
                            <Authorized allOf={item.permissions ?? []}>
                                <th className={`"truncate ${item.responsive ?? "table-cell"} ${item.width ?? "w-fit"} ${item.textDirection ?? "text-center"}`}>{item.label}</th>
                            </Authorized>
                        ))}
                    </tr>
                </thead>
                <tbody>{props.tbody}</tbody>
            </table>
        </div>
    )
}
